module.exports = __webpack_public_path__ + "static/media/trash.83e75f57.svg";